import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../../context/PaymentsUI/context.js';
import { usePaypalClientConfiguration } from '../../../../context/Paypal/PaypalClientConfigurationContext.js';
import { usePaypalPaymentEvents } from '../../../../context/Paypal/PaypalPaymentEventsContext.js';
import { PaypalActionButton } from './PaypalActionButton.js';

const PaypalActionButtonContainer = ({ isDisabled  })=>{
    const paypalConfig = usePaypalClientConfiguration();
    const paypalPaymentEvents = usePaypalPaymentEvents();
    if (!paypalConfig) {
        console.error('Paypal configuration is required for PaypalButton');
        return null;
    }
    if (!paypalPaymentEvents.createOrder && !paypalPaymentEvents.createBillingAgreement || !paypalPaymentEvents.onApprove) {
        console.error('Paypal events are required for PaypalButton');
        return null;
    }
    return /*#__PURE__*/ React.createElement(PaypalActionButton, {
        isDisabled: isDisabled,
        events: paypalPaymentEvents,
        orderType: paypalPaymentEvents.orderType
    });
};

export { PaypalActionButtonContainer };
//# sourceMappingURL=PaypalActionButtonContainer.js.map
